module.exports = __webpack_public_path__ + "img/sec2_2_m.4aff405c.png";